import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import EndMenu from '../ui/EndMenu';
import UIAssetKeys from '../UIAssetKeys';
import Title from './Title';

export default class FinalScene extends Phaser.Scene
{
    static get KEY() { return 'FinalScene'; }

    constructor()
    {
        super({ key: (FinalScene).KEY });
    }

    create()
    {
        this.bg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._more_assets_EndBackground, this).setOrigin(0);

        let hangLocs = [
            { x: 96, y: 192 },
            { x: 96, y: 175 },
            { x: 96, y: 60 },
            { x: 96, y: 85 }
        ];

        let pos = hangLocs[gameData.selectedType];

        this.userBackpack = this.add.image(pos.x, pos.y, "backpack").setScale(0.8).setOrigin(0);

        this.hook = ABCyaPhaser.Images.addImage(377, 225, UIAssetKeys._more_assets_hook_front, this).setOrigin(0);

        this.menu = new EndMenu(this);
        this.menu.y = this.scale.height - this.menu.workingHeight - 60;
        this.add.existing(this.menu);

        this.cameras.main.alpha = 0;
        this.tweens.add(
            {
                targets: this.cameras.main,
                duration: 1000,
                props: { alpha: 1 },
                ease: Phaser.Math.Easing.Quadratic.In,
                onComplete: () =>
                {
                    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._SchoolBell, this);
                }
            }
        );
    }

    nextScene()
    {
        this.scene.start(Title.KEY);
    }

    save()
    {
        this.menu.alpha = 0;

        this.renderer.snapshot(async snapshot =>
        {
            try
            {
                await ABCyaLib.PrintSave.instance.saveImage(snapshot, { fileName: ABCyaPhaser.Localization.instance.getLocalizedString("print_screen.save_file_name") });
            }
            catch (ex)
            {
                console.warn(ex);
            }

            this.menu.alpha = 1;
        });
    }

    print()
    {
        this.menu.alpha = 0;

        this.renderer.snapshot(async snapshot =>
        {
            try
            {
                await ABCyaLib.PrintSave.instance.printImage(snapshot);
            }
            catch (ex)
            {
                console.warn(ex);
            }

            this.menu.alpha = 1;
        });
    }
}